export default __webpack_public_path__ + "static/media/necklace.79f33c5b.png";